import { render, staticRenderFns } from "./VATReportBEList.vue?vue&type=template&id=29108c8e&scoped=true&"
import script from "./VATReportBEList.vue?vue&type=script&lang=js&"
export * from "./VATReportBEList.vue?vue&type=script&lang=js&"
import style0 from "./VATReportBEList.vue?vue&type=style&index=0&id=29108c8e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29108c8e",
  null
  
)

export default component.exports